import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppStateService} from './app-state.service';
import {MapFile} from '../model/map-file';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapFileService {
  private get userId(): string {
    return this.appStateService.user?.userId;
  }

  constructor(private http: HttpClient, private appStateService: AppStateService) {
  }

  getMapFiles(): Observable<MapFile[]> {
    return this.http.get<MapFile[]>(`${environment.apiUrl}/map-files`);
  }

  addMapFile(mapFile: MapFile, files?: File): Observable<MapFile> {
    const formData = new FormData();
    Object.keys(mapFile).forEach(key => {
      formData.append(key, mapFile[key]);
    });
    if (files) {
      formData.append('files', files);
    }
    return this.http.post<MapFile>(
      `${environment.apiUrl}/map-files`,
      formData
    );
  }

  deleteMapFile(filedId: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/map-files/${filedId}`);
  }

  updateMapFile(mapFile: MapFile, file?: File): Observable<MapFile> {
    const formData = new FormData();
    Object.keys(mapFile).forEach(key => {
      formData.append(key, mapFile[key]);
    });
    if (file) {
      formData.append('files', file);
    }
    return this.http.put<MapFile>(
      `${environment.apiUrl}/map-files/${mapFile._id}`,
      formData
    );
  }

  getMapFileDetails(filedId: string): Observable<MapFile> {
    return this.http.get<MapFile>(`${environment.apiUrl}/map-files/${filedId}`);
  }

  getMapFileMetadata(tilesetId: string, lat: number, lng: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}/map-files/${tilesetId}/${lat}/${lng}`);
  }
}
